import { ActionType, createReducer, StateType } from 'typesafe-actions'

import { RequestResponseData } from '../../types'
import * as actions from './actions'
import { IncludeCitiesOptions } from './types'

export const initialState: RequestResponseData<IncludeCitiesOptions[]> = {
  data: [],
  loading: false,
  error: null,
}

const requestState = {
  data: [],
  loading: true,
  error: null,
}

export type State = RequestResponseData<IncludeCitiesOptions[]>

export const themeCitiesReducer = createReducer(initialState)
  .handleAction(
    actions.funnelOrderThemeCitiesGetRequest,
    (state: State, action: ActionType<typeof actions.funnelOrderThemeCitiesGetRequest>) => requestState,
  )
  .handleAction(actions.funnelOrderThemeCitiesGetResponse, (state:State, action: ActionType<typeof actions.funnelOrderThemeCitiesGetResponse> ) => ({
    data: [...action.payload],
    loading: false,
    error: null,
  }))
  .handleAction(actions.funnelOrderThemeCitiesGetFailure, (state: State, action: ActionType<typeof actions.funnelOrderThemeCitiesGetFailure>) => ({
    data: [],
    loading: false,
    error: action.payload,
  }))
